<template>
  <div>
    <img :src="posterSrc" alt="poster" class="poster-img" />
    <play-button-mask @click="$emit('click')" />
  </div>
</template>

<script>
  import PlayButtonMask from './components/PlayButtonMask.vue';
  export default {
    components: {
      PlayButtonMask
    },
    props: {
      posterSrc: {
        type: File | String,
        required: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  .poster-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/SlideFragment/slideComponents/VideoPlayer/VideoPlayerPreview.vue